// List of charts available on Home screen to feed the "Filtro de gráficos" dropdown
// Each item contains a human-readable name and a slug identifier

const homeChartOptions = [
  { chart: "DASHBOARD_CHARTS.DRIVER_RANKING", slug: "table-drivers", menuId: 95003 },
  { chart: "DASHBOARD_CHARTS.GREATER_CIRCULATION", slug: "vehiclesCirculationBar", menuId: 95004 },
  { chart: "DASHBOARD_CHARTS.GREATER_IDLENESS", slug: "vehiclesIdlenessStacked", menuId: 95005 },
  { chart: "DASHBOARD_CHARTS.OUTSIDE_WORK_HOURS", slug: "offHoursStacked", menuId: 95006 },
  { chart: "DASHBOARD_CHARTS.WEEKLY_CIRCULATION", slug: "offHoursLine", menuId: 95007 },
  { chart: "DASHBOARD_CHARTS.SPEED_LIMIT", slug: "speedLimit", menuId: 95008 },
  { chart: "DASHBOARD_CHARTS.TRANSIT_FINES", slug: "table-multas", menuId: 0 },
];

export default homeChartOptions;


